export const HOME_URL = '/'
export const LEADERBOARD_URL = '/leaderboard'
export const TERMS_CONDITIONS_URL = '/terms-conditions'
export const PRIVACY_POLICY_URL = '/privacy-policy'
